module.exports = __webpack_public_path__ + "asset/image-ic_category_18-3a9f3cbd3c2ced1c.svg";


//////////////////
// WEBPACK FOOTER
// ./src/application/component/category-icon/image/ic_category_18.svg
// module id = DRWz
// module chunks = 0